// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"fea6234b","618":"2c558231"}[chunkId] + ".chunk.css";
};